// removed by extract-text-webpack-plugin
module.exports = {"Apple":"_44vjvuS3Oil-hlLi7LJQI","Dell":"_1okrxgyjxZQz1CozBDDQ6f","Abbott":"_3183STVklriKgFRvSvfduL","Gap":"gG0gL1pVK0RIla5yccNyr","Allstate":"_1-ovuHK9WFX-zzY2Fudctc","Asurion":"_33_b_gHdZSbHcexjg6xH-p","Invitae":"_1TuCzs2p_Xv85fJmfgE3qe","JWE":"_3aNUgWy0JsFK92m-ffyfWs"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/themes/index.scss
// module id = DOYI
// module chunks = 12